import { RootState } from '@reducers';

export const selectCarPolicyDetails = (state: RootState) => state.userDashboardRouteReducer.policyDetailsReducer.carPolicyDetailsReducer;
